AGADash.Events = (function () {

    var idCount = 1;

    var allEventHandlers = [];

    var allEventNames = {};

    var isValidEventName = function (eventName) {
        return allEventNames[eventName];
    };

    var registerEventName = function (eventName) {
        allEventNames[eventName.toLowerCase()] = true;
    };

    var unregisterEventName = function (eventName) {
        allEventNames[eventName.toLowerCase()] = false;
    };

    var on = function (eventName, selector, functionCallback) {
        var en = eventName.toLowerCase();
        if (!isValidEventName(en))
            throw new Error(eventName + " não é um evento válido.");

        var info = {
            id: idCount++,
            evt: en,
            sel: selector,
            func: functionCallback
        };

        allEventHandlers.push(info);
        return info.id;
    };

    var remove = function (handlerId) {
        allEventHandlers = allEventHandlers.filter(function (info) {
            return (info.id !== handlerId);
        });
    };

    var invoke = function (eventName, selector, argumentFn) {
        var eventNameLower = eventName.toLowerCase();

        var eventList = allEventHandlers.filter(function (info) {
            if (info.evt !== eventNameLower)
                return false;

            return ((info.sel === "*") || (info.sel === selector));
        });

        AGA.log("AGADash.Events.invoke(" + eventNameLower + ")[" + eventList.length.toString() + " listener(s)]");

        // Se nenhum evento foi encontrado deve sair
        if (eventList.length === 0)
            return;

        // Chamar o criador de parâmetros
        var args = $.extend(argumentFn(), { selector: selector, eventName: eventNameLower });

        for (var i = 0; i < eventList.length; i++) {
            eventList[i].func(args);
        }
    };

    var getBaseEventArguments = function (anyElement) {
        var root = AGADash.Panel.getPanelRoot(anyElement);
        var id = $(root).attr("data-id");
        var uid = $(root).attr("data-uid");
        return {
            "id": id,
            "uid": uid,
            "root": root
        };
    };

    var anyInvoke = function (eventName, anyTarget) {
        var args = getBaseEventArguments(anyTarget);
        invoke(eventName, args.uid, function () { return args; });
    };

    return {

        registerEventName: registerEventName,
        unregisterEventName: unregisterEventName,

        on: on,

        remove: remove,

        // Executar os eventos
        invoke: invoke,

        anyInvoke: anyInvoke,

        // Buscar informações basicas
        getBaseEventArguments: getBaseEventArguments

    };

})();